
















































import {
  ref,
  computed,
  defineComponent,
  useFetch,
  useRouter,
} from '@nuxtjs/composition-api';
import { useUser } from '~/modules/customer/composables/useUser';
import userGetters from '~/modules/customer/getters/userGetters';
import { SfHeading } from '@storefront-ui/vue';
import { useUiState } from '~/composables/useUiState';
import { getMetaInfo } from '~/helpers/getMetaInfo';

export default defineComponent({
   name: "Track-Order",
   components: {
        SfHeading,
   },
   setup(){
    const userEmail = ref<any | null>(null);
    const orderId = ref<any | null>(null);
    const getEmail = ref<any | null>(null);
    var errorMsg = ref<any | null>(null);
    const { isAuthenticated, user, load: loadUser } = useUser();
    const router = useRouter();
    if (isAuthenticated) {
        useFetch(async () => {
            await loadUser();
            getEmail.value = computed(() => userGetters.getEmailAddress(user.value));
            userEmail.value = getEmail.value.value;
        });
    }
    const getOrderDetaile = async (userEmail, orderId) => {
        if (userEmail && orderId) {
            if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(userEmail)) {
                if (orderId) {
                    router.push({ path: "/order/orderDetail", query: { orderId: `${orderId}`, email: `${userEmail}` } });
                } else {
                    alert('Please enter a valid Order Id!');
                }
            } else {
                alert('Please enter a valid email address (Ex: example@domain.com).');
            }
        } else {
            alert('Please enter a valid orderId and valid email address (Ex: example@domain.com).');
        }
    };
    const { isHelpModelOpen, toggleHelpModal, isOpenHelpPopup, openHelpPopup } = useUiState();
    if(isHelpModelOpen.value == true){
        toggleHelpModal();
    }
    if(isOpenHelpPopup.value == true){
        openHelpPopup();
    }

    const pageMeta = {
        "meta_title": null,
        "meta_description": null,
        "meta_keywords": null,
        "name": "Midwest Photo Track Order",
    };
    return {
        userEmail,
        getOrderDetaile,
        orderId,
        errorMsg,
        pageMeta
    }
   },
   head() {
        return getMetaInfo(this.pageMeta);
    },
});
